import { generateClient } from 'aws-amplify/api';
import { logOutCRM } from '@alucio/aws-beacon-amplify/src/graphql/queries';
import * as logger from 'src/utils/logger'
import { CRMIntegrationSession } from 'src/state/machines/CRM/util';
import { ICRMSessionHandler } from '../CRMHandler';

export class SalesforceSessionHandler implements ICRMSessionHandler {
  async logOut(crmSession?: CRMIntegrationSession): Promise<void> {
    if (!crmSession?.accessToken) {
      return;
    }

    try {
      logger.CRMMachine.info('Ending CRM auth session by logging out')
      const appsyncClient = generateClient();
      await appsyncClient.graphql({
        query: logOutCRM,
        variables: {
          accessToken: crmSession.accessToken,
        },
      });
    }
    catch (e: any) {
      if (e.errors?.[0]?.message === 'Invalid session id') {
        logger.salesforceSyncer.warn('Invalid session id', e);
      }
      else {
        throw e;
      }
    }
  }
}
